import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { disablePrimeMemberEligibility } from "src/api/primestockapi";
import { notification } from "src/utils/messages";

export default function RemoveFromEligibleModal({
  rowData,
  toggleRemoveEligibleModal,
  removeEligibleModal,
  handleGetWelcomekitMemberList,
  tabValue,
  filtereddata,
  p_id,
  p_a_p_id,
  p_type
}) {
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    borderRadius: "10px",
    boxShadow: 10,
    p: 4,
    overflowY: "auto"
  };

  const [removeEligibleReason, setRemoveEligibleReason] = useState({
    date: moment().format("DD-MM-YYYY"),
    d_kit_eligibility_reason: "",
    m_id: rowData?.m_id,
    eligible_date: rowData?.joining_date,
    user_name: loginUser.name,
    u_id: loginUser.u_id,
    p_id: p_id,
    p_a_p_id: p_a_p_id,
    p_type: p_type
  });
  const [loader, setLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleDisableEligibility = async () => {
    // API CALL

    if (removeEligibleReason.d_kit_eligibility_reason.trim() === "") {
      let notify = notification({
        type: "error",
        message: "Please Enter Reason"
      });
      notify();
    } else {
      setLoader(true);
      setIsLoading(true);
      const resp = await disablePrimeMemberEligibility({ ...removeEligibleReason });
      setIsLoading(false);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
      if (resp.status != 0) {
        toggleRemoveEligibleModal();
        handleGetWelcomekitMemberList(tabValue, filtereddata);
      }
      setLoader(false);
    }
  };

  return (
    <Modal
      open={removeEligibleModal}
      onClose={toggleRemoveEligibleModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalStyle}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6"> ({rowData?.m_name})</Typography>
        </Box>
        <hr />

        <Stack style={{ marginBottom: "15px" }}>
          <Grid container spacing={1}>
            <Grid
              item
              sm={12}
              xs={12}
              md={12}
              lg={12}
              style={{ marginBottom: "15px", marginTop: "15px" }}
            >
              <TextField
                fullWidth
                autoComplete="off"
                type="textarea"
                multiline
                rows={2}
                label="Reason"
                name="d_kit_eligibility_reason"
                required
                size="small"
                placeholder="Enter Reason"
                onChange={(e) => {
                  setRemoveEligibleReason({
                    ...removeEligibleReason,
                    d_kit_eligibility_reason: e.target.value
                  });
                }}
                value={removeEligibleReason?.d_kit_eligibility_reason}
              />
            </Grid>
            <Grid
              item
              sm={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => toggleRemoveEligibleModal()}
                style={{ marginTop: "15px", marginRight: "15px" }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                style={{ marginTop: "15px" }}
                onClick={() => !loader && handleDisableEligibility()}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </Modal>
  );
}
